import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Collapse, Drawer, Typography } from 'antd'
import { FC, useState } from 'react'

const { Paragraph, Text } = Typography

const HelpDrawer: FC = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button icon={<QuestionCircleOutlined />} onClick={() => setOpen(true)}>
                Справка
            </Button>
            <Drawer title='Задачи куратора' open={open} onClose={() => setOpen(false)} width={480}>
                <Collapse
                    defaultActiveKey={['1']}
                    items={[
                        {
                            key: '1',
                            label: <b>Обзор</b>,
                            children: (
                                <>
                                    <Paragraph>
                                        Здесь отображаются задачи типа{' '}
                                        <Text strong>«Согласование задания»</Text> по отгрузкам
                                        ваших менеджеров.
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            Вкладка <Text strong>Новые</Text> — ожидают решения.
                                        </li>
                                        <li>
                                            Вкладка <Text strong>Завершенные</Text> — согласованные
                                            или отклонённые.
                                        </li>
                                    </ul>
                                </>
                            ),
                        },
                        {
                            key: '2',
                            label: <b>Действия</b>,
                            children: (
                                <ul>
                                    <li>
                                        <Text strong>Согласовать</Text> — завершает задачу и ставит
                                        статус отгрузки «Согласован». После этого дизайнеры могут
                                        завершать остальные задачи, доступен спуск в печать.
                                        Отрисовку бланка можно завершить и до согласования.
                                    </li>
                                    <li>
                                        <Text strong>Отклонить</Text> — завершает задачу, статус
                                        отгрузки «Отклонено». Менеджер может вернуть ту же задачу
                                        на согласование: она снова появится в «Новых».
                                    </li>
                                </ul>
                            ),
                        },
                    ]}
                />
            </Drawer>
        </>
    )
}

export default HelpDrawer
